<!-- Display the content for the visited route. -->
<router-outlet></router-outlet>
<div id="push"></div>
